import React, { useRef, memo } from 'react';
import ReactEChartsCore from '../EChart';
import * as echarts from 'echarts/core';
import { Card } from 'react-bootstrap';
import {
  TooltipComponent,
  TitleComponent,
  GridComponent
} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { useAppContext } from '../../../providers/AppProvider';
import dayjs from 'dayjs';

echarts.use([
  TooltipComponent,
  TitleComponent,
  GridComponent,
  LineChart,
  CanvasRenderer
]);

const getDefaultOptions = (theme, getThemeColor, data) => {
  if (!data || typeof data !== 'object') {
    console.warn('Data is undefined or invalid:', data);
    return {
      xAxis: { type: 'category' },
      yAxis: { type: 'value' },
      series: []
    };
  }

  // const series = Object.entries(data).flatMap(([key, machineData]) => {
  //   if (!machineData || typeof machineData !== 'object') {
  //     console.warn(`Invalid machine data for key: ${key}`, machineData);
  //     return [];
  //   }

  //   return Object.entries(machineData)
  //     .map(([machineName, machineValues]) => {
  //       if (!Array.isArray(machineValues)) {
  //         console.warn(
  //           `Invalid data array for machine: ${machineName}`,
  //           machineValues
  //         );
  //         return null;
  //       }

  //       return {
  //         name: `${key} (${machineName})`,
  //         type: 'line',
  //         data: machineValues,
  //         showSymbol: false,
  //         symbol: 'circle',
  //         smooth: true,
  //         lineStyle: { color: getThemeColor('primary') },
  //         itemStyle: { color: getThemeColor('primary') }
  //       };
  //     })
  //     .filter(Boolean);
  // });

  const series = Object.entries(data)
    .map(([key, machineData]) => {
      if (!machineData || typeof machineData !== 'object') {
        console.warn(`Invalid machine data for key: ${key}`, machineData);
        return [];
      }

      return Object.entries(machineData)
        .map(([machineName, machineValues]) => {
          if (!Array.isArray(machineValues)) {
            console.warn(
              `Invalid data array for machine: ${machineName}`,
              machineValues
            );
            return null;
          }

          return {
            name: `${key} (${machineName})`,
            type: 'line',
            data: machineValues,
            showSymbol: false,
            symbol: 'circle',
            smooth: true,
            lineStyle: { color: getThemeColor('primary') },
            itemStyle: { color: getThemeColor('primary') }
          };
        })
        .filter(Boolean);
    })
    .reduce((acc, val) => acc.concat(val), []);

  return {
    color: series.map(series => series.itemStyle.color),
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'line'
      },
      formatter: params =>
        params
          .map(
            ({ seriesName, value, axisValue }) =>
              `<div>${axisValue} - ${seriesName}: ${value}</div>`
          )
          .join('')
    },
    xAxis: {
      type: 'time',
      boundaryGap: false,
      axisLabel: {
        formatter: value => dayjs(value).format('DD MMM YYYY, HH:mm:ss'),
        margin: 10,
        color: getThemeColor('gray-800'),
        fontFamily: 'Nunito Sans',
        fontWeight: 600,
        fontSize: 12.8
      },
      axisLine: {
        lineStyle: {
          color: getThemeColor('gray-300')
        }
      },
      axisTick: {
        alignWithLabel: true
      }
    },
    yAxis: {
      type: 'value',
      axisLine: { lineStyle: { color: getThemeColor('gray-300') } },
      splitLine: {
        show: true,
        lineStyle: { color: getThemeColor('gray-300') }
      },
      axisLabel: {
        color: getThemeColor('gray-900'),
        formatter: '{value}'
      }
    },
    series,
    grid: {
      right: 40,
      left: 20,
      bottom: '30px', // Adjust to accommodate labels
      top: '10%',
      containLabel: true
    },
    animation: false
  };
};

const Dinamic2LineChart = ({ data, title }) => {
  const chartRef = useRef(null);
  const {
    config: { theme },
    getThemeColor
  } = useAppContext();

  return (
    <Card className="h-100">
      <Card.Body>
        <div style={styles.headerContainer}>
          <div style={styles.title}>{title}</div>
        </div>
        <ReactEChartsCore
          ref={chartRef}
          echarts={echarts}
          option={getDefaultOptions(theme, getThemeColor, data)}
          style={{ height: '316px', width: '100%' }}
        />
      </Card.Body>
    </Card>
  );
};

const styles = {
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px'
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold'
  }
};

export default memo(Dinamic2LineChart);
